import {
  LOAD_FEEDBACK_FAILURE,
  LOAD_FEEDBACK_REQUEST,
  LOAD_FEEDBACK_SUCCESS,
  LOAD_SUPPLEMENTS_FEEDBACK_FAILURE,
  RECEIVE_CONSULTATION_SURVEY_INFOS,
  RECEIVE_ORDER_INFOS,
  RECEIVE_SUPPLEMENTS_ORDER_INFOS,
  SAVE_END_OF_ROAD_MESSAGE,
  SAVE_FEEDBACK_FAILURE,
  SAVE_FEEDBACK_REQUEST,
  SAVE_FEEDBACK_SUCCESS,
  SAVE_HAIRCARE_FEEDBACK_STATUS,
  SAVE_SUPPLEMENTS_FEEDBACK_STATUS,
} from 'dux/feedback/actionTypes';

const initialState = {
  consultationSurvey: {},
  data: {},
  endOfTheRoadMessage: null,
  error: null,
  haircareFeedbackCompleted: false,
  haircareOrder: {},
  status: 'idle',
  supplementsOrder: {},
  supplementsFeedbackCompleted: false,
};

export default function feedbackReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_FEEDBACK_REQUEST:
      return {
        ...state,
        status: 'loading',
      };
    case LOAD_FEEDBACK_SUCCESS:
      return {
        ...state,
        status: 'success',
      };
    case LOAD_FEEDBACK_FAILURE:
      return {
        ...state,
        error: action.error,
        status: 'error',
      };
    case LOAD_SUPPLEMENTS_FEEDBACK_FAILURE:
      return {
        ...state,
        error: action.error,
        status: 'error',
      };

    case SAVE_FEEDBACK_REQUEST:
      return {
        ...state,
        status: 'saving',
      };
    case SAVE_FEEDBACK_SUCCESS:
      return {
        ...state,
        data: action.data,
        status: 'success',
      };
    case SAVE_FEEDBACK_FAILURE:
      return {
        ...state,
        error: action.error,
        status: 'error',
      };
    case SAVE_END_OF_ROAD_MESSAGE:
      return {
        ...state,
        endOfTheRoadMessage: action.endOfTheRoadMessage,
      };
    case SAVE_HAIRCARE_FEEDBACK_STATUS:
      return {
        ...state,
        haircareFeedbackCompleted: action.status,
      };
    case SAVE_SUPPLEMENTS_FEEDBACK_STATUS:
      return {
        ...state,
        supplementsFeedbackCompleted: action.status,
      };

    case RECEIVE_ORDER_INFOS:
      return {
        ...state,
        data: action.data,
        haircareOrder: action.order,
      };
    case RECEIVE_SUPPLEMENTS_ORDER_INFOS:
      return {
        ...state,
        supplementsOrder: action.order,
      };

    case RECEIVE_CONSULTATION_SURVEY_INFOS:
      return {
        ...state,
        consultationSurvey: action.consultationSurvey,
      };

    default:
      return state;
  }
}
